import { useCallback, useEffect, useState } from "react"
import { getTotalVXCHNGStaked, getUserVXCHNGBalance, getUserVXCHNGStakes, getVShareClaimable, getVShareClaimed } from "services/daoServices"
import { useAppSelector } from "./redux/hooks"

import { useAccount, mainnet } from "wagmi"
import { createPublicClient, createWalletClient, custom, formatUnits, http, parseGwei, parseUnits } from "viem"
import daoAbi from "data/daoAbi"
import inscriptionABI from "data/abi"
import toast from "react-hot-toast"
import daoClaimAbi from "data/daoClaimAbi"

const rpcUrl = 'https://eth.llamarpc.com'

// ETH
const contractAddress = '0xDDEfd7eFe2C84FD58F31cCE20983c0e9e79e0b6F'
const xChngContractAddress = '0xb712d62fe84258292d1961b5150a19bc4ab49026'
const claimContractAddress = '0x1f4eF6305523999E7bcB1Ce0d62a47Da90a8D508'

const rewardTokenAddressList = [
    '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT
    '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', // USDC
    '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', // ETH
    '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599', // WBTC
    '0xb712d62fe84258292d1961b5150a19bc4ab49026'  // XCHNG
]

// ARB
// const contractAddress = '0xD5a73b0dCd2cA2aC5F1F09931D16deFA58669F0B'
// const xChngContractAddress = '0x51c601dc278eb2cfea8e52c4caa35b3d6a9a2c26'
// const claimContractAddress = '0xe4a20C4E5C2F830283b28C40f2f019fcCbF1e450'

// const rewardTokenAddressList = [
//     '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9', // USDT
//     '0xaf88d065e77c8cc2239327c5edb3a432268e5831', // USDC
//     '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', // ETH
//     '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f', // WBTC
//     '0x51c601dc278eb2cfea8e52c4caa35b3d6a9a2c26'  // XCHNG
// ]

const useDao = (run: boolean = true) => {
    const { isConnected } = useAppSelector((state) => state.wallet)
    const { address, connector } = useAccount();
    const [userVoting, setUserVoting] = useState('0')
    const [totalStaking, setTotalStaking] = useState('0')
    const [totalStakedXCHNG, setTotalStakedXCHNG] = useState('0')
    const [totalVXCHNGStaked, setTotalVXCHNGStaked] = useState('0')
    const [stakeList, setStakeList] = useState([])
    const [isLock, setIsLock] = useState(false)
    const [yourPower, setYourPower] = useState('0')
    const [claimable, setClaimable] = useState<any>({})
    const [claimed, setClaimed] = useState<any>({})

    const fnGetTotalVXCHNGStaked = useCallback(async () => {
        const result = await getTotalVXCHNGStaked()
        if(result) {
            const { totalVXCHNGStaked = '0', totalXCHNGStaked = '0' } = result
            setTotalVXCHNGStaked(formatUnits(totalVXCHNGStaked, 18))
            setTotalStaking(formatUnits(totalXCHNGStaked, 18))
        }
    }, [])

    const fnGetUserVXCHNGBalance = useCallback(async () => {
        if(isConnected && address) {
            const result = await getUserVXCHNGBalance(address)
            if(result) {
                // balance = '0',
                const {  hrpBalance = '0' } = result
                setUserVoting(hrpBalance)
            }
        }
    }, [isConnected, address])


    const fnGetUserVXCHNGStakes = useCallback(async () => {
        if(isConnected && address) {
            const result = await getUserVXCHNGStakes(address)
            if(result) {
                const { stakeIndex,  stakeList, totalXCHNGStaked} = result
                const hrpTotalXCHNGStaked = formatUnits(totalXCHNGStaked, 18)
                setTotalStakedXCHNG(hrpTotalXCHNGStaked)
                setStakeList(Object.values(stakeList))
            }
        }
    }, [isConnected, address])

    // getVShareClaimed

    const formatAmount = useCallback((amount: {[key: string]:any}) => {
        return {
            USDT: formatUnits(BigInt(amount?.USDT), 6),
            USDC: formatUnits(BigInt(amount?.USDC), 6),
            WBTC: formatUnits(BigInt(amount?.WBTC), 8),
            ETH: formatUnits(BigInt(amount?.ETH), 18),
            XCHNG: formatUnits(BigInt(amount?.XCHNG), 18)
        }
    }, [])

    const checkHasVal = (obj: {[key:string]: any} = {}) => {
        const values = Object.values(obj)
        let isClamied = false
        for(let i = 0, length = values.length; i < length; i++) {
            if(+values[i] > 0) {
                isClamied = true
                break
            }
        }

        return isClamied
    }

    const getVShareClaimedForAll = useCallback(async() => {
        try {
            if(address) {
                const fullYear = new Date().getFullYear()
                const requestAll = [getVShareClaimed({address, period: `${fullYear}01`}), getVShareClaimed({address, period: `${fullYear}02`}), getVShareClaimed({address, period: `${fullYear}03`}), getVShareClaimed({address, period: `${fullYear}04`})]
                const resultList = await Promise.all(requestAll)
                if(resultList.length) {
                    setClaimed({
                        q1: formatAmount(resultList[0].amount),
                        q2: formatAmount(resultList[1].amount),
                        q3: formatAmount(resultList[2].amount),
                        q4: formatAmount(resultList[3].amount),
                    })
                }
            }
        } catch(error) {

        } finally {

        }
    }, [address, formatAmount])

    const getVShareClaimableForAll = useCallback(async() => {
        try {
            if(address) {
                const fullYear = new Date().getFullYear()
                const requestAll = [getVShareClaimable({address, period: `${fullYear}01`}), getVShareClaimable({address, period: `${fullYear}02`}), getVShareClaimable({address, period: `${fullYear}03`}), getVShareClaimable({address, period: `${fullYear}04`})]
                const resultList = await Promise.all(requestAll)
                if(resultList.length) {
                    setClaimable({
                        q1: formatAmount(resultList[0].amount),
                        q2: formatAmount(resultList[1].amount),
                        q3: formatAmount(resultList[2].amount),
                        q4: formatAmount(resultList[3].amount),
                    })
                }
            }
        } catch(error) {

        } finally {

        }
        
    }, [address, formatAmount])

    useEffect(() => {
        if(run) {
            fnGetTotalVXCHNGStaked()
            fnGetUserVXCHNGBalance()
            fnGetUserVXCHNGStakes()
        }
    }, [fnGetTotalVXCHNGStaked, fnGetUserVXCHNGBalance, fnGetUserVXCHNGStakes, run])

    useEffect(() => {
        const tempPercent = ((+userVoting) / (+totalVXCHNGStaked) * 100).toFixed(1)
        setYourPower((+totalVXCHNGStaked) === 0 ? '0 %' : (tempPercent + ' %'))
    }, [totalVXCHNGStaked, userVoting])

    const fnApprove = async (publicClient: any, walletClient: any, userAddress: string, amount: bigint) => {
        try { 
            let gasPrice = await publicClient?.getGasPrice();
            gasPrice = gasPrice * BigInt(3) / BigInt(2)
            const amountStr = amount.toString()
            let gasLimit = await publicClient?.estimateContractGas({
                address: xChngContractAddress,
                abi: inscriptionABI,
                functionName: "approve",
                account: userAddress,
                gasPrice: gasPrice,
                args: [contractAddress, amountStr],
            });

            const hash = await walletClient?.writeContract({
                address: xChngContractAddress,
                abi: inscriptionABI,
                functionName: "approve",
                account: userAddress,
                chain: mainnet,
                gasPrice: gasPrice,
                gas: gasLimit,
                args: [contractAddress, amountStr],
            });
            const txInfo = await publicClient?.waitForTransactionReceipt({
                hash: hash,
            });
            if (txInfo.status.toLowerCase() !== "success") {
                toast.error("Approval failed, try again later.", {
                  duration: 3000,
                  position: "top-right",
                });
                return false;
            }
            return true
        } catch(error) {
            throw error
        }
    }

    const createStake = useCallback(async (amount: string, duration: string) => {
        try {
            if(isLock) return
            setIsLock(true)
            const provider = await connector?.getProvider();
            const userAddress = address as `0x${string}`
            const publicClient = createPublicClient({
                chain: mainnet,
                transport: http(rpcUrl),
            }) as any;
            const amountBI = parseUnits(amount, 18)
            // 合约准备
            const walletClient = createWalletClient({
                account: userAddress,
                chain: mainnet,
                transport: custom(provider),
            }) as any;

            const allowanceResultBI = await publicClient.readContract({
                address: xChngContractAddress,
                abi: inscriptionABI,
                functionName: "allowance",
                args: [userAddress, contractAddress],
            });

            let approveAmountBI = amountBI
            if(allowanceResultBI) {
                if (allowanceResultBI < amountBI) {
                    approveAmountBI = amountBI - allowanceResultBI;
                    // 补充不足的approve
                    const approveResult = await fnApprove(publicClient, walletClient, userAddress, approveAmountBI)
                    if(!approveResult) return
                }
            } else {
                // approve
                const approveResult = await fnApprove(publicClient, walletClient, userAddress, approveAmountBI)
                if(!approveResult) return
            }
            let gasPrice = await publicClient?.getGasPrice();
            gasPrice = gasPrice * BigInt(3) / BigInt(2)
            let gasLimit = await publicClient?.estimateContractGas({
                address: contractAddress,
                abi: daoAbi,
                functionName: "stake",
                account: userAddress,
                gasPrice: gasPrice,
                args: [amountBI, duration],
            });

            await walletClient?.writeContract({
                address: contractAddress,
                abi: daoAbi,
                functionName: "stake",
                account: userAddress,
                chain: mainnet,
                gasPrice: gasPrice,
                gas: gasLimit,
                args: [amountBI, duration],
            });
        } catch(error: any) {
            const errorStr = JSON.stringify(error);
            let errorMsg = "";
            if (errorStr.includes("shortMessage")) {
              errorMsg = error.shortMessage;
            } else {
              errorMsg = "Service unavailable, try again later.";
            }
            if (errorMsg) {
              toast.error(errorMsg, {
                duration: 3000,
                position: "top-right",
              });
            }
        } finally {
            setIsLock(false)
        }
    }, [address, connector, isLock])

    const claimRewards = useCallback(async(period: string) => {
        try {
            if(isLock) return
            setIsLock(true)
            const provider = await connector?.getProvider();
            const userAddress = address as `0x${string}`
            const publicClient = createPublicClient({
                chain: mainnet,
                transport: http(rpcUrl),
            }) as any;
            // 合约准备
            const walletClient = createWalletClient({
                account: userAddress,
                chain: mainnet,
                transport: custom(provider),
            }) as any;

            let gasPrice = await publicClient?.getGasPrice();
            gasPrice = gasPrice * BigInt(3) / BigInt(2)
            let gasLimit = await publicClient?.estimateContractGas({
                address: claimContractAddress,
                abi: daoClaimAbi,
                functionName: "claim",
                account: userAddress,
                gasPrice: gasPrice,
                args: [period, rewardTokenAddressList],
            });
            
            const hash =  await walletClient?.writeContract({
                address: claimContractAddress,
                abi: daoClaimAbi,
                functionName: "claim",
                account: userAddress,
                chain: mainnet,
                gasPrice: gasPrice,
                gas: gasLimit,
                args: [period, rewardTokenAddressList],
            });
            await publicClient?.waitForTransactionReceipt(
                {
                    hash: hash,
                }
            )
        } catch(error: any) {
            const errorStr = JSON.stringify(error);
            let errorMsg = "";
            if (errorStr.includes("shortMessage")) {
              errorMsg = error.shortMessage;
            } else {
              errorMsg = "Service unavailable, try again later.";
            }
            if (errorMsg) {
              toast.error(errorMsg, {
                duration: 3000,
                position: "top-right",
              });
            }
        } finally {
            setIsLock(false)
        }
    }, [address, connector, isLock])

    const getClaimEnabled = useCallback(async (period: string) => {
        try {
            const publicClient = createPublicClient({
                chain: mainnet,
                transport: http(rpcUrl),
            }) as any;
            const result = await publicClient.readContract({
                address: claimContractAddress,
                abi: daoClaimAbi,
                functionName: "claimEnabled",
                args: [period],
            });
            return result
        } catch(error) {

        } finally {
            
        }
    }, [])

    const getCurrentPeriod = useCallback(async () => {
        try {
            const publicClient = createPublicClient({
                chain: mainnet,
                transport: http(rpcUrl),
            }) as any;
            const result = await publicClient.readContract({
                address: claimContractAddress,
                abi: daoClaimAbi,
                functionName: "currentPeriod"
            });
            return result
        } catch(error) {

        } finally {
            
        }
    }, [])

    return {
        userVoting,
        totalStaking,
        totalStakedXCHNG,
        stakeList,
        yourPower,

        claimable,
        claimed,
        totalVXCHNGStaked,

        isLock,

        createStake,
        getVShareClaimableForAll,
        getVShareClaimedForAll,

        getCurrentPeriod,
        getClaimEnabled,
        claimRewards,

        checkHasVal
    }
}

export default useDao